export function omitKeys<T extends Record<string, unknown>>(
  obj: T,
  ...keys: (keyof T)[]
): Record<string, T[keyof T]> {
  const keySet = new Set(keys)
  return Object.fromEntries(
    Object.entries(obj).filter(([k]) => !keySet.has(k))
  ) as Record<string, T[keyof T]>
}
